<div class="pageheader">
  <div class="page-title">
    <h1>Stakeholders</h1>
    <div class="btn-toolbar">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Stakeholder_Action_ShowLog'" [title]="'Stakeholders log'">
        <app-change-log-link-entity type="Stakeholder"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div x-class="container container-fixed">
  <div class="row">
    <div class="col-sm-12">
      <dx-data-grid biz-grid [selection]='{ mode: "none" }' [showIsLoading]="isLoading" [dataSource]='allStakeholders.Rows' (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)">

        <dxo-editing mode="popup" [allowAdding]="allowAdding" [allowUpdating]="allowUpdating" [allowDeleting]="allowDeleting"></dxo-editing>
        <dxo-grouping expandMode="rowClick"></dxo-grouping>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxi-column dataField="StakeholdersName" caption="Name" [validationRules]="[{ type: 'required' }]" dataType="string"></dxi-column>
        <dxi-column dataField="Description" caption="Description" [validationRules]="[{ type: 'required' }]" dataType="string"></dxi-column>
        <dxi-column dataField="EmailAddress" caption="Email" dataType="string">
          <dxi-validation-rule type="custom" [validationCallback]="customEmailValidationCallback"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="EmailAddressUrgent" caption="Email Urgent" dataType="string">
          <dxi-validation-rule type="custom" [validationCallback]="customEmailValidationCallback"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="EmailAddressCc" caption="Email Cc" dataType="string">
          <dxi-validation-rule type="custom" [validationCallback]="customEmailValidationCallback"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="EmailAddressBcc" caption="Email Bcc" dataType="string">
          <dxi-validation-rule type="custom" [validationCallback]="customEmailValidationCallback"></dxi-validation-rule>
        </dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(allStakeholders.Rows, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(allStakeholders.Rows, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

        <dxi-column type="buttons">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
          </dxi-button>
        </dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'UserGroup_Action_ShowLog'" [title]="'Logs for ' + cell.data.StakeholdersName" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Stakeholder" [id]="cell.data.StakeholderId"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>
      </dx-data-grid>
    </div>
  </div>
</div>
